import { Heading, Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { useProjectName } from './ProjectPreviewModalContext';
import ProjectPreviewModalHeadingSubtitle from './ProjectPreviewModalHeadingSubtitle';
import { block } from './utils';

export interface ProjectPreviewModalHeadingProps {}

const ProjectPreviewModalHeading: React.FC<ProjectPreviewModalHeadingProps> = () => {
  const projectName = useProjectName();

  return (
    <Spacer
      space="8px"
      orientation="vertical"
      align="flex-start"
      className={block('heading-container')}
    >
      <Heading level={1} lineHeight={1} className={block('project-name')}>
        {projectName}
      </Heading>

      <Text
        variant="p"
        textTransform="uppercase"
        weight="normal"
        letterSpacing="2px"
        lineHeight={1}
        className={block('project-subtitle')}
      >
        <ProjectPreviewModalHeadingSubtitle />
      </Text>
    </Spacer>
  );
};

export default ProjectPreviewModalHeading;
